import useApiClient from "./use_api_client"

const useApiResource = (options = {}) => {
  const path = options.path
  const version = options.version || "2018-08-01"
  const defaultData = options.data || {}
  const app = options.app || "registrations"
  const singular = options.singular || false
  const client = useApiClient(app, version)

  const resourcePath = id => (singular || !id ? path : `${path}/${id}`)

  const index = (data = {}) => {
    return client.get({
      url: resourcePath(),
      data: { ...defaultData, ...data }
    })
  }

  const create = (attributes, data = {}) => {
    return client.post({
      url: resourcePath(),
      data: {
        ...defaultData,
        ...data,
        data: { attributes }
      }
    })
  }

  const find = (id = null, data = {}) => {
    return client.get({
      url: resourcePath(id),
      data: { ...defaultData, ...data }
    })
  }

  const update = (id = null, attributes, data = {}) => {
    return client.patch({
      url: resourcePath(id),
      data: {
        ...defaultData,
        ...data,
        data: { attributes }
      }
    })
  }

  const destroy = (id = null, data = {}) => {
    return client.delete({
      url: resourcePath(id),
      data: { ...defaultData, ...data }
    })
  }

  const run = (path, data = {}) => {
    return client.post({
      url: `${resourcePath()}/${path}`,
      data: { ...defaultData, ...data }
    })
  }

  return {
    index,
    create,
    find,
    update,
    destroy,
    run
  }
}

export default useApiResource
